export const DEFAULT_TRANSCRIPTION_LANGUAGES = ["en", "es", "fr", "de", "it", "pt", "ja"];

const LANGUAGE_ALIASES = {
  english: "en",
  spanish: "es",
  french: "fr",
  german: "de",
  italian: "it",
  portuguese: "pt",
  japanese: "ja",
  korean: "ko",
  chinese: "zh"
};

const LANGUAGE_LABELS = {
  en: "English",
  es: "Spanish",
  fr: "French",
  de: "German",
  it: "Italian",
  pt: "Portuguese",
  ja: "Japanese",
  ko: "Korean",
  zh: "Chinese"
};

export function normalizeLanguageCode(value) {
  if (!value || typeof value !== "string") return "";

  const trimmed = value.trim();
  if (!trimmed) return "";

  const lowered = trimmed.toLowerCase();
  if (LANGUAGE_ALIASES[lowered]) {
    return LANGUAGE_ALIASES[lowered];
  }

  const fromLocale = lowered.split("-")[0];
  if (/^[a-z]{2}$/.test(fromLocale)) {
    return fromLocale;
  }

  return "";
}

export function resolveTranscriptionLanguages(agent) {
  const fromAgent = Array.isArray(agent?.targetLanguages) ? agent.targetLanguages : [];
  const normalized = fromAgent.map(normalizeLanguageCode).filter(Boolean);
  const unique = Array.from(new Set(normalized));

  if (unique.length > 0) {
    return unique;
  }

  return DEFAULT_TRANSCRIPTION_LANGUAGES;
}

export function resolveInitialTranscriptionLanguage(browserLanguage, languages) {
  const normalizedBrowserLanguage = normalizeLanguageCode(browserLanguage);
  const normalizedLanguages = (languages || []).map(normalizeLanguageCode).filter(Boolean);

  if (normalizedBrowserLanguage && normalizedLanguages.includes(normalizedBrowserLanguage)) {
    return normalizedBrowserLanguage;
  }

  return normalizedLanguages[0] || "en";
}

export function getLanguageLabel(languageCode) {
  const normalized = normalizeLanguageCode(languageCode);
  if (!normalized) return "Unknown";
  return LANGUAGE_LABELS[normalized] || normalized.toUpperCase();
}
